import { useCallback } from 'react';

import ToastComponent, { IToastType } from '../components/Toast/ToastComponent';
import { useDeletePintoEbookCollectionMutation } from '../core/graphql/operation-hooks';

const useMutationDeletePintoEbookCollection = () => {
  const [mutate, { loading }] = useDeletePintoEbookCollectionMutation();

  const deletePintoEbookCollection = useCallback(
    async (ebookCollectionId: string) => {
      try {
        const res = await mutate({ variables: { ebookCollectionId } });
        if (res.data?.deletePintoEbookCollection?.success) {
          return { success: true };
        } else {
          ToastComponent({ label: res.data?.deletePintoEbookCollection?.message || 'Delete failed.', type: IToastType.ERROR });
          return { success: false };
        }
      } catch (err) {
        ToastComponent({ label: 'An error occurred.', type: IToastType.ERROR });
        return { success: false };
      }
    },
    [mutate],
  );

  return { deletePintoEbookCollection, isDeleting: loading };
};

export default useMutationDeletePintoEbookCollection;
